import { ApiOutletProductTax } from '@vend/types'

import { EntityStore } from './entity-store'

/**
 * Stores information on the retailer's product taxes for the current active outlet.
 */
class ProductTaxesStore extends EntityStore<'productTaxes'> {
  constructor() {
    'ngInject'
    super({
      entityStoreName: 'productTaxes',
      entityName: 'outlet_taxes',
      filterByOutlet: true,
    })
  }

  /**
   * Remove the given outlet product tax from the IndexedDB store. Overridden as need to remove by
   * `product_id` instead of `id`.
   *
   * @param  entity
   *         The outlet product tax to remove from the store
   *
   * @return A promise resolved once the outlet product tax has been successfully removed
   */
  protected removeEntity(entity: ApiOutletProductTax) {
    return this.dbStore.del(entity.product_id)
  }
}

export const productTaxesStore = new ProductTaxesStore()
